<template>
  <avz-user-types />
</template>

<script>
import UserTypes from '@/components/UserTypes'

export default {
  components: {
    'avz-user-types': UserTypes
  }
}
</script>
